import React from "react";

import { Nullable } from "models/Nullable";
import { OfferRoom } from "models/OfferRoom";

import { SummaryList, TTableGroupData, TTableRowData } from "./SummaryTable";

type Props = {
    offerRooms: OfferRoom[]
    discount?: Nullable<number>
    manualPrice: Nullable<number>
    offerRoomComments?: { [offerRoomId: string]: string }
    offerRoomNames?: { [offerRoomId: string]: string }
    setOfferRoomComments?: (value: { [offerRoomId: string]: string }) => void
    setOfferRoomNames?: (value: { [offerRoomId: string]: string }) => void
    hideUnitPrices: boolean
}

export function DetailedSummaryTable({ offerRooms, discount, manualPrice, offerRoomComments, setOfferRoomComments, offerRoomNames, setOfferRoomNames, hideUnitPrices }: Props) {
    const groups: TTableGroupData[] = offerRooms.map(offerRoom => ({
        groupId: offerRoom.id,
        roomId: offerRoom.room.id,
        groupName: offerRoom.room.name,
        rows: Object.values(offerRoom.priceFields).map(({ id: priceFieldId, count: priceFieldCount, priceField }): TTableRowData => ({
            priceFieldId,
            priceFieldName: priceField.name?.text,
            priceFieldCount,
            priceFieldPrice: priceField.price,
        }))
    }));
    return (
        <SummaryList
            hideUnitPrices={hideUnitPrices}
            discount={discount}
            manualPrice={manualPrice}
            groups={groups}
            offerRoomComments={offerRoomComments}
            setOfferRoomComments={setOfferRoomComments}
            offerRoomNames={offerRoomNames}
            setOfferRoomNames={setOfferRoomNames}
        />
    )
}